// apps/sprint-expert/src/app/services/expert-sse.service.ts

import { Injectable } from '@angular/core';
import { BaseSseService } from '@libs/shared/services/base-sse.service';
import { SseAccessTokenProvider } from '@sprint-expert/app/core/sse/sse-access-token-provider.service';
import { injectCoreFeature } from '@sprint-expert/app/core/state/core.service';
import { environment } from '@sprint-expert/environments/environment';

@Injectable({ providedIn: 'root' })
export class SseService extends BaseSseService {
  readonly core = injectCoreFeature();

  constructor(protected override accessTokenProvider: SseAccessTokenProvider) {
    super(accessTokenProvider, environment);
  }

  protected handleEvent(eventType: string, data: any): void {
    switch (eventType) {
      case 'AppStatus':
        this.core.fetchAppStatus();
        break;
      case 'ExpertEventNotification':
        this.core.fetchExpertEventNotificationUnreadCount();
        break;
      case 'Expert':
        this.core.fetchCurrentExpert();
        break;
      case 'heartbeat':
        break;
      default:
        console.warn(
          `BackofficeSseService: Unhandled event type: ${eventType}`,
          data
        );
    }
  }
}
